import React, { Component } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './Home'
import Viewer from './Viewer'


class App extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <div>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/view"
                element={
                  <Viewer uri={this.props.uri} viewerPermissions={this.props.viewerPermissions} ratingOptions={this.props.ratingOptions}
                    enhancedEvents={this.props.enhancedEvents} onError={this.props.onError} referrer={this.props.referrer}
                    clientActionId={this.props.clientActionId} startTimestamp={this.props.startTimestamp} permsSignature={this.props.permsSignature} />
                }
              />
            </Routes>
          </div>
        </BrowserRouter>
      </div>
    )
  }
}

export default App
